import type { NavigationExtractItem } from '@cli-types/next-adapter/generators.js'
import { quoteLiteral, toCamelCase } from '@cli-utils/text.js'
import { renderBuildNavigationExtractSourceImportsTemplate } from '@next-adapter/templates/renderers/generators/navigation-extract.js'

export function buildNavigationExtractSource(
  schemaName: string,
  item: NavigationExtractItem
): string {
  const lines = [
    `    label: ${quoteLiteral(item.label)}`,
    `    href: ${quoteLiteral(item.href)}`,
    `    icon: ${item.icon}`
  ]

  if (item.group !== undefined) {
    lines.push(`    group: ${quoteLiteral(item.group)}`)
  }
  if (item.groupIcon !== undefined) {
    lines.push(`    groupIcon: ${item.groupIcon}`)
  }
  if (item.groupPosition != null) {
    lines.push(`    groupPosition: ${item.groupPosition}`)
  }
  if (item.position != null) {
    lines.push(`    position: ${item.position}`)
  }

  const icons = Array.from(
    new Set([item.icon, ...(item.groupIcon === undefined ? [] : [item.groupIcon])])
  ).sort()

  return renderBuildNavigationExtractSourceImportsTemplate({
    join: icons.join(', '),
    toCamelCase: toCamelCase(schemaName),
    joinText: lines.join(',\n')
  })
}
